
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.647 27.998c-.21 0-.432-.058-.618-.174l-7.977-4.956-7.976 4.956a1.16 1.16 0 01-1.33-.07 1.16 1.16 0 01-.407-1.26l2.985-9.889L.49 11.743a1.18 1.18 0 01-.454-1.248 1.157 1.157 0 011.002-.863l8.956-.991L12.968.758A1.174 1.174 0 0114.064 0c.49 0 .921.303 1.096.758l2.974 7.883 8.839 1.003c.478.058.875.396.991.863.117.466-.058.956-.443 1.236l-6.717 4.84 2.985 9.888a1.16 1.16 0 01-.408 1.26c-.21.163-.454.244-.711.244l-.023.023zm-8.595-7.672c.21 0 .432.058.618.174l5.97 3.709-2.331-7.732c-.14-.478.035-.99.431-1.283l4.945-3.568-6.543-.746a1.159 1.159 0 01-.956-.746l-2.134-5.656-2.134 5.656a1.16 1.16 0 01-.968.746l-6.623.735 5.026 3.568c.408.291.583.805.443 1.283l-2.332 7.731 5.97-3.708c.187-.117.408-.175.618-.175v.012z","fill":"#262626"}})])
          )
        }
      }
    